import axios from 'axios';

export function isTransientError(error: any): boolean {
  if (axios.isAxiosError(error)) {
    if (!error.response || error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK') {
      return true;
    }
    const status = error.response.status;
    return status >= 500 || status === 408;
  }
  return false;
}

export default isTransientError;
